import i18n from "i18next";

/**
 * Resolved locale for `Intl.NumberFormat` and other display numbers:
 * **ar-DZ** when the active language is Arabic, otherwise **fr-DZ**, matching currency formatting.
 *
 * Reads {@link i18n.language} at call time (not cached at module load).
 */
export function getAppNumberLocale(): "ar-DZ" | "fr-DZ" {
  const lang = i18n.language ?? "en";
  return lang.startsWith("ar") ? "ar-DZ" : "fr-DZ";
}
